import React from "react";

const FancyTextBlockTen = () => {
  return (
    <>
      <div className="row align-items-end">
        <div
          className="col-xl-5 col-lg-6 ms-auto order-lg-last"
          data-aos="fade-left"
          data-aos-duration="1200"
        >
          <img src="images/icon/34.svg" alt="" className="icon" />
          <p className="font-rubik">
          Chúng tôi cam kết đem đến cho khách hàng những sản phẩm và dịch vụ tiên tiến nhất với chất lượng tốt nhất.
          </p>
          <div className="name sm-mb-40">
          Lương Quí Thăng{" "}
            <span>
              CEO & Founder <br />
              LTC
            </span>
          </div>
        </div>
        {/* End .col */}

        <div className="col-lg-6 order-lg-first">
          <div className="row align-items-end">
            <div
              className="col-6"
              data-aos="fade-right"
              data-aos-duration="1200"
              data-aos-delay="100"
            >
              <img src="images/assets/screen_25.jpg" alt="" className="img-meta" />
            </div>
            <div
              className="col-6"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <img src="images/assets/screen_26.jpg" alt="" className="img-meta" />
            </div>
          </div>
        </div>
      </div>
      {/* End .row */}

      <div className="row">
        <div className="col-lg-10 ms-auto">
          <div className="img-gallery mt-60 md-mt-20">
            <div className="row">
              <div
                className="col-sm-5 sm-mb-20"
                data-aos="fade-up"
                data-aos-duration="1200"
              >
                <img
                  src="images/assets/screen_27.jpg"
                  alt="media"
                  className="img-meta"
                />
              </div>
              <div
                className="col-sm-7"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="100"
              >
                <img
                  src="images/assets/screen_28.jpg"
                  alt="media"
                  className="img-meta"
                />
              </div>
            </div>
          </div>
          {/* /.img-gallery */}
        </div>
      </div>
      {/* End .row */}
    </>
  );
};

export default FancyTextBlockTen;
